import { render, staticRenderFns } from "./physical-activity-history.vue?vue&type=template&id=1c8139aa&"
import script from "./physical-activity-history.vue?vue&type=script&lang=js&"
export * from "./physical-activity-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFormLabel: require('@chakra-ui/vue').CFormLabel, CFormControl: require('@chakra-ui/vue').CFormControl, CInput: require('@chakra-ui/vue').CInput, CInputGroup: require('@chakra-ui/vue').CInputGroup, CSelect: require('@chakra-ui/vue').CSelect, CBox: require('@chakra-ui/vue').CBox})
